'use client';

import { ButtonSecondary } from '@portals/ui-kit';
import React, { FC } from 'react';

type TProps = {
  text: string;
};

export const ToMainPageButton: FC<TProps> = ({ text }) => {
  return <ButtonSecondary text={text} />;
};
